/* Gratia Pearl custom Klaviyo Back-in-Stock modal */
(function () {
  "use strict";

  var KLAVIYO_REVISION = "2026-04-15";
  var KLAVIYO_BIS_SOURCE = "Waitlist Popup All-in-one";
  var KLAVIYO_INTER_REQUEST_DELAY_MS = 500;
  var KLAVIYO_SUBMIT_TIMEOUT_SECONDS = 15;

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function parseProductJson(root) {
    var script = root.querySelector("[data-bis-product-json]");
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error("[Gratia BIS] Could not parse product JSON.", error);
      return null;
    }
  }

  function normalizeAutoCloseSeconds(value) {
    var parsed = parseInt(value, 10);
    if (Number.isNaN(parsed) || parsed < 1) return 3;
    return Math.min(parsed, 10);
  }

  function isSuccessStatus(status) {
    return status === 200 || status === 201 || status === 202 || status === 204 || status === 409;
  }

  function isValidE164(phone) {
    return /^\+[1-9]\d{7,14}$/.test(phone);
  }

  function createAbortError() {
    var error = new Error("Request timed out.");
    error.name = "AbortError";
    return error;
  }

  function delay(ms, signal) {
    return new Promise(function (resolve, reject) {
      if (signal && signal.aborted) {
        reject(createAbortError());
        return;
      }

      var abortHandler = null;
      var timeout = window.setTimeout(function () {
        if (signal && abortHandler) {
          signal.removeEventListener("abort", abortHandler);
        }
        resolve();
      }, ms);

      if (signal) {
        abortHandler = function () {
          window.clearTimeout(timeout);
          reject(createAbortError());
        };
        signal.addEventListener("abort", abortHandler, { once: true });
      }
    });
  }

  function throwIfAborted(signal) {
    if (signal && signal.aborted) {
      throw createAbortError();
    }
  }

  function setMessage(messageEl, text, state) {
    if (!messageEl) return;

    messageEl.textContent = text || "";

    if (state) {
      messageEl.dataset.state = state;
    } else {
      messageEl.removeAttribute("data-state");
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.bisInitialized === "true") return;
    root.dataset.bisInitialized = "true";

    var product = parseProductJson(root);
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) {
      console.warn("[Gratia BIS] Missing product/variant data.");
      return;
    }

    var config = {
      publicKey: root.dataset.klaviyoPublicKey || "",
      marketingListId: root.dataset.klaviyoMarketingListId || "",
      autoCloseSeconds: normalizeAutoCloseSeconds(root.dataset.autoCloseSeconds),
      enableSms: root.dataset.enableSms === "true",
      enableEmailMarketing: root.dataset.enableEmailMarketing !== "false",
      emailMarketingDefaultChecked: root.dataset.emailMarketingDefaultChecked !== "false",
      buttonText: root.dataset.buttonText || "See price + Notify me",
      successButtonText: root.dataset.successButtonText || "You're on the waitlist",
    };

    var els = {
      openButton: root.querySelector("[data-bis-open]"),
      modal: root.querySelector("[data-bis-modal]"),
      form: root.querySelector("[data-bis-form]"),
      formPanel: root.querySelector("[data-bis-form-panel]"),
      successPanel: root.querySelector("[data-bis-success-panel]"),
      image: root.querySelector("[data-bis-image]"),
      productTitle: root.querySelector("[data-bis-product-title]"),
      variantTitle: root.querySelector("[data-bis-variant-title]"),
      price: root.querySelector("[data-bis-price]"),
      comparePrice: root.querySelector("[data-bis-compare-price]"),
      email: root.querySelector("[data-bis-email]"),
      name: root.querySelector("[data-bis-name]"),
      emailMarketingBlock: root.querySelector("[data-bis-email-marketing-block]"),
      emailMarketing: root.querySelector("[data-bis-email-marketing]"),
      phone: root.querySelector("[data-bis-phone]"),
      smsBlock: root.querySelector("[data-bis-sms-block]"),
      message: root.querySelector("[data-bis-message]"),
      successCopy: root.querySelector("[data-bis-success-copy]"),
      countdown: root.querySelector("[data-bis-countdown]"),
      pdpConfirmation: root.querySelector("[data-bis-pdp-confirmation]"),
      pdpConfirmationCopy: root.querySelector("[data-bis-pdp-confirmation-copy]"),
      submitButton: root.querySelector("[data-bis-submit]"),
      consentPromptButton: root.querySelector("[data-bis-consent-prompt]"),
    };

    if (!els.openButton || !els.modal || !els.form) {
      console.warn("[Gratia BIS] Required markup missing.");
      return;
    }

    if (els.smsBlock) {
      els.smsBlock.hidden = !config.enableSms;
    }

    if (els.emailMarketingBlock) {
      els.emailMarketingBlock.hidden = !config.enableEmailMarketing;
    }

    if (els.emailMarketing) {
      els.emailMarketing.checked = config.emailMarketingDefaultChecked;
      els.emailMarketing.required = config.enableEmailMarketing;
    }

    var autoCloseTimeout = null;
    var countdownInterval = null;
    var pdpConfirmationTimeout = null;
    var lastVariantId = null;
    var modalPlaceholder = document.createComment("gratia-bis-modal-placeholder");
    var subscribedVariantIds = [];

    function markVariantSubscribed(variantId) {
      if (!variantId) return;

      var id = String(variantId);
      if (subscribedVariantIds.indexOf(id) === -1) {
        subscribedVariantIds.push(id);
      }
    }

    function isVariantSubscribed(variantId) {
      if (!variantId) return false;
      return subscribedVariantIds.indexOf(String(variantId)) !== -1;
    }

    function getProductScope() {
      return root.closest(".m-main-product") || root.closest("[id^='shopify-section-']") || document;
    }

    function getPurchaseControls() {
      var scope = getProductScope();
      var forms = Array.prototype.slice.call(scope.querySelectorAll("form[data-type='add-to-cart-form']"));
      var controls = [];

      function addControl(control) {
        if (control && controls.indexOf(control) === -1) {
          controls.push(control);
        }
      }

      forms.forEach(function (form) {
        var wrapper = form.querySelector(".m-product-form--wrapper");
        addControl(wrapper || form);
      });

      Array.prototype.forEach.call(document.querySelectorAll('[data-view="sticky-atc"], .m-sticky-addtocart'), addControl);

      return controls;
    }

    function syncPurchaseControls(shouldHide) {
      getPurchaseControls().forEach(function (control) {
        if (shouldHide) {
          if (!control.hasAttribute("data-gratia-bis-purchase-hidden")) {
            control.dataset.gratiaBisOriginalAriaHidden = control.getAttribute("aria-hidden") || "";
          }

          control.setAttribute("data-gratia-bis-purchase-hidden", "true");
          control.setAttribute("aria-hidden", "true");
          return;
        }

        if (control.getAttribute("data-gratia-bis-purchase-hidden") !== "true") return;

        if (control.dataset.gratiaBisOriginalAriaHidden) {
          control.setAttribute("aria-hidden", control.dataset.gratiaBisOriginalAriaHidden);
        } else {
          control.removeAttribute("aria-hidden");
        }

        control.removeAttribute("data-gratia-bis-purchase-hidden");
        delete control.dataset.gratiaBisOriginalAriaHidden;
      });
    }

    function getSelectedVariantId() {
      var scope = getProductScope();
      var forms = Array.prototype.slice.call(scope.querySelectorAll("form[action*='/cart/add']"));
      var input = null;

      for (var i = 0; i < forms.length; i += 1) {
        input = forms[i].querySelector("[name='id']");
        if (input && input.value) return String(input.value);
      }

      input = scope.querySelector("[name='id']") || document.querySelector("form[action*='/cart/add'] [name='id']");
      if (input && input.value) return String(input.value);

      var urlVariant = new URLSearchParams(window.location.search).get("variant");
      if (urlVariant) return String(urlVariant);

      if (product.selectedVariantId) return String(product.selectedVariantId);
      return String(product.variants[0].id);
    }

    function getSelectedVariant() {
      var selectedId = getSelectedVariantId();
      var found = product.variants.find(function (variant) {
        return String(variant.id) === String(selectedId);
      });

      return found || product.variants[0];
    }

    function getVariantLabel(variant) {
      if (!variant || !variant.title || variant.title === "Default Title") return "";
      return variant.title;
    }

    function hasRequiredEmailMarketingConsent() {
      if (!config.enableEmailMarketing || !els.emailMarketing) return true;
      return els.emailMarketing.checked;
    }

    function syncConsentButtons() {
      var canSubmit = hasRequiredEmailMarketingConsent();

      if (els.submitButton) {
        els.submitButton.hidden = !canSubmit;
      }

      if (els.consentPromptButton) {
        els.consentPromptButton.hidden = canSubmit;
      }
    }

    function renderModalProduct() {
      var variant = getSelectedVariant();
      if (!variant) return;

      if (els.image) {
        els.image.src = variant.image || product.featuredImage || "";
        els.image.alt = product.title || "";
      }

      if (els.productTitle) {
        els.productTitle.textContent = product.title || "";
      }

      if (els.variantTitle) {
        els.variantTitle.textContent = getVariantLabel(variant);
        els.variantTitle.hidden = !getVariantLabel(variant);
      }

      if (els.price) {
        els.price.textContent = variant.price || "";
      }

      if (els.comparePrice) {
        els.comparePrice.textContent = variant.compareAtPrice || "";
        els.comparePrice.hidden = !variant.compareAtPrice;
      }
    }

    function hidePdpConfirmation() {
      window.clearTimeout(pdpConfirmationTimeout);
      pdpConfirmationTimeout = null;

      if (els.pdpConfirmation) {
        els.pdpConfirmation.hidden = true;
      }
    }

    function showPdpConfirmation(variant, afterSubmit) {
      if (!els.pdpConfirmation) return;

      if (els.pdpConfirmationCopy) {
        els.pdpConfirmationCopy.textContent = "You're on the waitlist. We'll contact you when this item is available.";
      }

      els.pdpConfirmation.hidden = false;
      window.clearTimeout(pdpConfirmationTimeout);
      pdpConfirmationTimeout = window.setTimeout(hidePdpConfirmation, 5000);

      if (afterSubmit && els.openButton) {
        els.openButton.textContent = config.successButtonText;
        els.openButton.disabled = true;
      }
    }

    function syncButton() {
      var variant = getSelectedVariant();
      if (!variant) return;

      var alreadySubscribed = isVariantSubscribed(variant.id);
      var shouldShow = variant.available === false;

      syncPurchaseControls(shouldShow);
      els.openButton.hidden = !shouldShow;

      if (!shouldShow) {
        hidePdpConfirmation();
        return;
      }

      if (alreadySubscribed) {
        els.openButton.textContent = config.successButtonText;
        els.openButton.disabled = true;
        showPdpConfirmation(variant, false);
      } else {
        els.openButton.textContent = config.buttonText;
        els.openButton.disabled = false;
        hidePdpConfirmation();
      }
    }

    function clearTimers() {
      window.clearTimeout(autoCloseTimeout);
      window.clearInterval(countdownInterval);
      autoCloseTimeout = null;
      countdownInterval = null;
    }

    function moveModalToBody() {
      if (!els.modal || els.modal.parentNode === document.body) return;

      if (els.modal.parentNode) {
        els.modal.parentNode.insertBefore(modalPlaceholder, els.modal);
      }
      document.body.appendChild(els.modal);
    }

    function restoreModalLocation() {
      if (!els.modal || els.modal.parentNode !== document.body || !modalPlaceholder.parentNode) return;

      modalPlaceholder.parentNode.insertBefore(els.modal, modalPlaceholder);
      modalPlaceholder.parentNode.removeChild(modalPlaceholder);
    }

    function openModal() {
      var variant = getSelectedVariant();

      if (!variant || variant.available !== false || isVariantSubscribed(variant.id)) {
        syncButton();
        return;
      }

      renderModalProduct();
      setMessage(els.message, "", null);

      if (els.formPanel) els.formPanel.hidden = false;
      if (els.successPanel) els.successPanel.hidden = true;
      if (els.phone) {
        els.phone.required = false;
        els.phone.value = "";
      }
      if (els.name) {
        els.name.value = "";
      }
      if (els.emailMarketing) {
        els.emailMarketing.checked = config.emailMarketingDefaultChecked;
      }
      syncConsentButtons();

      moveModalToBody();
      els.modal.hidden = false;
      document.documentElement.classList.add("gratia-bis-is-open");
      document.body.classList.add("gratia-bis-is-open");
    }

    function closeModal() {
      clearTimers();
      els.modal.hidden = true;
      document.documentElement.classList.remove("gratia-bis-is-open");
      document.body.classList.remove("gratia-bis-is-open");

      if (els.formPanel) els.formPanel.hidden = false;
      if (els.successPanel) els.successPanel.hidden = true;
      if (els.form) els.form.reset();
      if (els.emailMarketing) els.emailMarketing.checked = config.emailMarketingDefaultChecked;
      if (els.phone) els.phone.required = false;
      setMessage(els.message, "", null);
      syncConsentButtons();
      restoreModalLocation();
    }

    function showSuccessPanel(variant, channels, smsWarning) {
      var secondsLeft = config.autoCloseSeconds;
      var usedSms = channels.indexOf("SMS") !== -1;

      clearTimers();

      if (els.formPanel) els.formPanel.hidden = true;
      if (els.successPanel) els.successPanel.hidden = false;

      if (els.successCopy) {
        if (usedSms) {
          els.successCopy.textContent = "We'll contact you by email and text when this exact item is available.";
        } else if (smsWarning) {
          els.successCopy.textContent =
            "You're on the email waitlist. We couldn't add text alerts for that phone number, but we'll email you when this exact item is available.";
        } else {
          els.successCopy.textContent = "We'll contact you when this exact item is available.";
        }
      }

      if (els.countdown) {
        els.countdown.textContent = String(secondsLeft);
      }

      countdownInterval = window.setInterval(function () {
        secondsLeft -= 1;
        if (els.countdown) {
          els.countdown.textContent = String(Math.max(secondsLeft, 0));
        }

        if (secondsLeft <= 0) {
          window.clearInterval(countdownInterval);
        }
      }, 1000);

      autoCloseTimeout = window.setTimeout(function () {
        closeModal();
        showPdpConfirmation(variant, true);
        syncButton();
      }, config.autoCloseSeconds * 1000);
    }

    function buildBackInStockPayload(profileAttributes, channels, variantId) {
      return {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes,
              },
            },
            channels: channels,
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + String(variantId),
              },
            },
          },
        },
      };
    }

    function buildMarketingSubscriptionPayload(profileAttributes) {
      var payload = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes,
              },
            },
            custom_source: KLAVIYO_BIS_SOURCE,
          },
        },
      };

      if (config.marketingListId) {
        payload.data.relationships = {
          list: {
            data: {
              type: "list",
              id: config.marketingListId,
            },
          },
        };
      }

      return payload;
    }

    function appendNameAttributes(profileAttributes, nameAttributes) {
      if (!nameAttributes) return profileAttributes;

      if (nameAttributes.firstName) {
        profileAttributes.first_name = nameAttributes.firstName;
      }

      if (nameAttributes.lastName) {
        profileAttributes.last_name = nameAttributes.lastName;
      }

      return profileAttributes;
    }

    function buildEmailMarketingSubscriptionPayload(email, nameAttributes) {
      return buildMarketingSubscriptionPayload(appendNameAttributes({
        email: email,
        subscriptions: {
          email: {
            marketing: {
              consent: "SUBSCRIBED",
            },
          },
        },
      }, nameAttributes));
    }

    function buildSmsMarketingSubscriptionPayload(email, phone, nameAttributes) {
      return buildMarketingSubscriptionPayload(appendNameAttributes({
        email: email,
        phone_number: phone,
        subscriptions: {
          sms: {
            marketing: {
              consent: "SUBSCRIBED",
            },
          },
        },
      }, nameAttributes));
    }

    function normalizePhoneNumber(phone) {
      if (!phone) return "";

      var trimmed = phone.trim();
      if (isValidE164(trimmed)) return trimmed;

      var digits = trimmed.replace(/\D/g, "");
      if (digits.length === 10) return "+1" + digits;
      if (digits.length === 11 && digits.charAt(0) === "1") return "+" + digits;

      return "";
    }

    function parseNameAttributes(name) {
      var trimmed = name ? name.trim().replace(/\s+/g, " ") : "";
      if (!trimmed) return null;

      var parts = trimmed.split(" ");
      return {
        firstName: parts[0],
        lastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
      };
    }

    async function getKlaviyoErrorDetail(response, fallback) {
      try {
        var errorJson = await response.json();
        return errorJson && errorJson.errors && errorJson.errors[0] && errorJson.errors[0].detail
          ? errorJson.errors[0].detail
          : fallback;
      } catch (error) {
        return fallback;
      }
    }

    function getFriendlySubmitError(error) {
      if (error && error.name === "AbortError") {
        return "The waitlist service is taking longer than usual. Please try again in a few minutes.";
      }

      if (error && /failed to fetch/i.test(error.message || "")) {
        return "The waitlist service is temporarily unavailable. Please try again in a few minutes.";
      }

      return error && error.message ? error.message : "Something went wrong. Please try again.";
    }

    function startSubmitCountdown(controller) {
      var secondsLeft = KLAVIYO_SUBMIT_TIMEOUT_SECONDS;

      function render() {
        var unit = secondsLeft === 1 ? "second" : "seconds";
        setMessage(els.message, "Saving your request... " + secondsLeft + " " + unit + " remaining.", null);
      }

      render();

      var interval = window.setInterval(function () {
        secondsLeft -= 1;
        if (secondsLeft > 0) {
          render();
        }
      }, 1000);

      var timeout = window.setTimeout(function () {
        controller.abort();
      }, KLAVIYO_SUBMIT_TIMEOUT_SECONDS * 1000);

      return function () {
        window.clearInterval(interval);
        window.clearTimeout(timeout);
      };
    }

    async function submitBackInStock(profileAttributes, channels, variantId, signal) {
      throwIfAborted(signal);

      if (!config.publicKey || config.publicKey.indexOf("REPLACE_WITH") !== -1) {
        throw new Error("Back-in-stock setup is missing the Klaviyo public site ID.");
      }

      var url =
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
        encodeURIComponent(config.publicKey);
      var payload = buildBackInStockPayload(profileAttributes, channels, variantId);

      var requestOptions = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify(payload),
      };

      if (signal) {
        requestOptions.signal = signal;
      }

      var response = await fetch(url, requestOptions);

      if (isSuccessStatus(response.status)) {
        return true;
      }

      var detail = await getKlaviyoErrorDetail(response, "Unable to save your request right now. Please try again.");
      throw new Error(detail);
    }

    async function submitKlaviyoMarketingConsent(payload, fallbackMessage, signal) {
      throwIfAborted(signal);

      if (!config.publicKey || config.publicKey.indexOf("REPLACE_WITH") !== -1) {
        throw new Error("Klaviyo subscription setup is missing the public site ID.");
      }

      var url =
        "https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(config.publicKey);

      var requestOptions = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify(payload),
      };

      if (signal) {
        requestOptions.signal = signal;
      }

      var response = await fetch(url, requestOptions);

      if (isSuccessStatus(response.status)) {
        return true;
      }

      var detail = await getKlaviyoErrorDetail(response, fallbackMessage);
      throw new Error(detail);
    }

    async function submitEmailMarketingConsent(email, nameAttributes, signal) {
      if (!config.enableEmailMarketing) {
        return true;
      }

      return submitKlaviyoMarketingConsent(
        buildEmailMarketingSubscriptionPayload(email, nameAttributes),
        "Unable to save your email updates opt-in right now. Please try again.",
        signal
      );
    }

    async function submitSmsMarketingConsent(email, phone, nameAttributes, signal) {
      if (!phone || !config.enableSms) {
        return true;
      }

      return submitKlaviyoMarketingConsent(
        buildSmsMarketingSubscriptionPayload(email, phone, nameAttributes),
        "Unable to save your text alert opt-in right now. Please try again.",
        signal
      );
    }

    async function handleSubmit(event) {
      event.preventDefault();

      var variant = getSelectedVariant();
      if (!variant || !variant.id) {
        setMessage(els.message, "Please select a product option first.", "error");
        return;
      }

      if (!els.form.checkValidity()) {
        els.form.reportValidity();
        return;
      }

      if (!hasRequiredEmailMarketingConsent()) {
        setMessage(els.message, "Please agree to email updates to join the waitlist.", "error");
        syncConsentButtons();
        return;
      }

      var email = els.email ? els.email.value.trim() : "";
      var name = els.name ? els.name.value.trim() : "";
      var nameAttributes = parseNameAttributes(name);
      var phone = els.phone ? els.phone.value.trim() : "";
      var normalizedPhone = "";
      var smsWarning = null;

      if (phone) {
        normalizedPhone = normalizePhoneNumber(phone);
        if (!normalizedPhone) {
          setMessage(els.message, "Please enter a valid phone number.", "error");
          return;
        }
      }

      var controller = "AbortController" in window ? new AbortController() : null;
      var signal = controller ? controller.signal : null;
      var stopSubmitCountdown = null;

      try {
        if (els.submitButton) els.submitButton.disabled = true;
        if (els.consentPromptButton) els.consentPromptButton.disabled = true;
        stopSubmitCountdown = controller ? startSubmitCountdown(controller) : null;
        if (!stopSubmitCountdown) {
          setMessage(els.message, "Saving your request...", null);
        }

        await submitEmailMarketingConsent(email, nameAttributes, signal);
        await delay(KLAVIYO_INTER_REQUEST_DELAY_MS, signal);
        await submitBackInStock({ email: email }, ["EMAIL"], variant.id, signal);

        var channels = ["EMAIL"];

        if (normalizedPhone && config.enableSms) {
          try {
            await delay(KLAVIYO_INTER_REQUEST_DELAY_MS, signal);
            await submitSmsMarketingConsent(email, normalizedPhone, nameAttributes, signal);
            await delay(KLAVIYO_INTER_REQUEST_DELAY_MS, signal);
            await submitBackInStock({ email: email, phone_number: normalizedPhone }, ["SMS"], variant.id, signal);
            channels.push("SMS");
          } catch (error) {
            smsWarning = error;
            console.warn("[Gratia BIS] SMS submission failed after email waitlist succeeded.", error);
          }
        }

        markVariantSubscribed(variant.id);
        setMessage(els.message, "", null);
        showSuccessPanel(variant, channels, smsWarning);
      } catch (error) {
        console.error("[Gratia BIS] Subscription failed.", error);
        setMessage(els.message, getFriendlySubmitError(error), "error");
      } finally {
        if (stopSubmitCountdown) stopSubmitCountdown();
        if (els.submitButton) els.submitButton.disabled = false;
        if (els.consentPromptButton) els.consentPromptButton.disabled = false;
      }
    }

    function handlePossibleVariantChange() {
      var currentId = getSelectedVariantId();
      if (currentId !== lastVariantId) {
        lastVariantId = currentId;
        syncButton();
      }
    }

    els.openButton.addEventListener("click", openModal);
    els.form.addEventListener("submit", handleSubmit);

    if (els.emailMarketing) {
      els.emailMarketing.addEventListener("change", function () {
        setMessage(els.message, "", null);
        syncConsentButtons();
      });
    }

    if (els.consentPromptButton) {
      els.consentPromptButton.addEventListener("click", function () {
        if (els.emailMarketing) {
          els.emailMarketing.checked = true;
          els.emailMarketing.focus();
        }
        setMessage(els.message, "", null);
        syncConsentButtons();
      });
    }

    function handleCloseClick(event) {
      var closeButton = event.target && event.target.closest("[data-bis-close]");
      if (closeButton) {
        closeModal();
      }
    }

    root.addEventListener("click", handleCloseClick);
    els.modal.addEventListener("click", handleCloseClick);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !els.modal.hidden) {
        closeModal();
      }
    });

    document.addEventListener("input", handlePossibleVariantChange);
    document.addEventListener("change", handlePossibleVariantChange);
    document.addEventListener("variant:changed", handlePossibleVariantChange);
    document.addEventListener("variant:change", handlePossibleVariantChange);
    document.addEventListener("shopify:section:load", handlePossibleVariantChange);

    lastVariantId = getSelectedVariantId();
    syncConsentButtons();
    syncButton();

    window.setInterval(handlePossibleVariantChange, 400);
  }

  function initAll() {
    var roots = document.querySelectorAll("[data-bis-root]");
    Array.prototype.forEach.call(roots, initRoot);
  }

  onReady(initAll);
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("gratia:product:swapped", initAll);
})();
